/**
 * FY selector — used by the Destinations and Monthly Revenue analytics tabs.
 *
 * Extracted into its own file ONLY because the visual-edits Babel plugin in
 * this repo recursively analyses inline JSX-with-iteration patterns and
 * crashes ("Maximum call stack size exceeded"). Keeping the `.map()`
 * isolated here lets the parent `Analytics.js` stay flat.
 *
 * Indian FY runs Apr→Mar. Format: "YYYY-YY" (e.g. "2025-26").
 */
import React from 'react';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';

const _currentFY = () => {
  const today = new Date();
  const sy = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
  return `${sy}-${String(sy + 1).slice(-2)}`;
};

const _fyOptions = () => {
  const cur = _currentFY();
  const sy = parseInt(cur.split('-')[0], 10);
  const out = [];
  for (let i = 0; i < 5; i += 1) {
    const y = sy - i;
    out.push(`${y}-${String(y + 1).slice(-2)}`);
  }
  return out;
};

export const CURRENT_FY = _currentFY();
export const FY_OPTIONS = _fyOptions();

const FYSelect = ({ value, onValueChange, testid }) => (
  <Select value={value} onValueChange={onValueChange}>
    <SelectTrigger className="w-40" data-testid={testid}>
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {FY_OPTIONS.map((opt) => (
        <SelectItem key={opt} value={opt}>FY {opt}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default FYSelect;
